import apiClient from "./api.client.service";

class CommonService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async getCurrentRegion(): Promise<"IND" | "OTHER"> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/common/my-region`
      );
      return response.data;
    } catch (error: any) {
      console.error("🚀 ~ CommonService ~ getCurrentRegion ~ error:", error);
      return "OTHER";
    }
  }
}

const commonService = new CommonService();

export default commonService;
